// 企业管理模块
import request from "../request.js";

// 查询项目列表
export const selectProjectListForJuyi = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/business/selectProjectListForJuyi",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 查询聚易厅项目数量
export const selectJuyiProjectNum = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/businessExpandJuyi/selectJuyiProjectNum",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 根据id查询项目详情
export const getProjectMsgByIdForJuyi = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/business/getProjectMsgByIdForJuyi",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 审核 修改（审核状态，运营撤回） 聚易厅 -- 陈启洋
export const auditProjectForJuyi = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/business/auditProject",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

//审核记录
export const getProjectAuditLog = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/operatorLog/getProjectAuditLog",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

/*--------
 项目管理--聚易厅项目
--------------------------*/

//列表

export const selectPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgJuyi/selectPageList",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};
//各状态的数量
export const selectPageNum = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgJuyi/selectPageNum",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

//查询详情
export const selectProjectById = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgJuyi/selectProjectById",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};
/*--------
 这里调聚易厅的微服务
--------------------------*/

//详情页-项目阶段记录接口
export const getStageRecords = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/busStageRecord/getStageRecords",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

//详情页-项目动态
export const getDynamicList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/busOpeRecord/getDynamicList",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

//详情页-项目当前状态
export const getSubProjectInfo = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getSubProjectInfo",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 获取投标人/投标保证金分页列表
export const getBidderList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getBidderList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 退还保证金
export const depositReleased = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/depositReleased",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 项目合同分页列表
export const getContractPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getContractPageList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 服务费托管
export const trusteeFeeGetProjectInfo = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/trusteeFeeGetProjectInfo",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 获取项目进度分页列表
export const getScheduleUpdatePageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getScheduleUpdatePageList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 获取项目成果验收分页列表
export const getAcceptPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getAcceptPageList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 获取项目佣金发放分页列表
export const getBusSettlementPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getBusSettlementPageList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

//查看开票申请信息分页列表
export const queryApplicationInvoiceList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/queryApplicationInvoiceList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

//查看发票
export const queryInvoice = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/queryInvoice",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

//获取雇主方评价信息分页列表
export const getEvaluatePageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getEvaluatePageList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

//查看雇主方评价
export const queryEvaluatePageInfo = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/queryEvaluatePageInfo",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

/*--------
 这里讯匠厅的服务
--------------------------*/

// 根据id查询项目详情
export const xunjiangselectProjectById = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgXunjiang/selectProjectById",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 查询数量
export const xunjiangselectPageNum = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgXunjiang/selectPageNum",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 讯匠通列表
export const xunjiangselectPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgXunjiang/selectPageList",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};
/*--------
 这里讯匠通的微服务
--------------------------*/
export const xjtOperation = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_XUNJIANG_URL,
    url: "/xjtOperation/getRecruitInfoById",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

export const getProviderApplyList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_XUNJIANG_URL,
    url: "/xjtOperation/getProviderApplyList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

/*--------
 项目管理--劳务通项目
--------------------------*/

// 劳务通列表
export const laowuselectPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgLaowu/selectListPage",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 查询数量
export const laowuselectPageNum = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgLaowu/selectNum",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 根据id查询项目详情
export const laowuselectProjectById = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgLaowu/selectProjectById",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 投递人名片
export const laowugetProviderApplyList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgLaowu/getProviderApplyList",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};
/*--------
 这里调劳务通的微服务
--------------------------*/
export const lwtOperation = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_LAOWU_URL,
    url: "/lwtOperation/getRecruitInfoById",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

/*--------
 项目管理--租赁通项目
--------------------------*/
// 租赁通列表
export const zulinselectPageList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/selectListPage",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 查询数量
export const zulinselectPageNum = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/selectNum",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 根据id查询项目详情
export const zulinselectProjectById = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/selectProjectById",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 步骤条
export const zulingetRelationList = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/getRelationList",
    method: "post",
    requestConfig: {
      hideLoading: true
    },
    data
  });
};

// 报价方保证金
export const zulinselectLessorQuotationInfo = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/selectLessorQuotationInfo",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 退款
export const refundApply = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/refundApply",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 交易完成
export const confirmTransactionCompletion = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/selectConfirmTransactionCompletion",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

// 合同列表
export const getContractInfo = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZulin/getContractInfo",
    method: "post",
    // requestConfig: {
    //   hideLoading: true
    // },
    data
  });
};

/*--------
 项目管理--专家通项目
--------------------------*/
export const selectListPage = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZhuanjia/selectListPage",
    method: "post",
    data
  });
};

// 审核查看
export const getProjectMsgByIdForZhuanjia = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/business/getProjectMsgByIdForJuyi",
    method: "post",
    data
  });
};

// 专家通详情
export const selectZJMsgById = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZhuanjia/selectZJMsgById",
    method: "post",
    data
  });
};

// 专家通 抽取结果和专家发放费用记录
export const getExtractResuit = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZhuanjia/getExtractResult",
    method: "post",
    data
  });
};

export const getExtractDetail = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_AUDIT_URL,
    url: "/projectMsgZhuanjia/selectExtractList",
    method: "post",
    data
  });
};

// 项目成果验收详情
export const getAcceptDetail = function(data) {
  return request({
    baseURL: process.env.VUE_APP_PROJECT_JUYI_URL,
    url: "/operation/getAcceptDetail",
    method: "post",
    data
  });
};
